<ng-container *ngIf="loadSecureImg">
	<div [ngClass]="logoClass" class="secure">
		<img
			[src]="logoUrl | secure | async"
			style="
				background-color: white;
				height: 100%;
				width: 100%;
				object-fit: contain;
			"
		/>
	</div>
</ng-container>
<ng-container *ngIf="!loadSecureImg">
	<div
		[ngClass]="logoClass"
		[ngStyle]="backgroundUrlStyle"
		class="insecure"
	></div>
</ng-container>
